import styled from 'styled-components';

import { DEVICE_SIZES } from '../../constants/common';

export const Wrapper = styled.div`
  width: 100%;

  ${({ theme }) => `
    background-color: ${theme.background1Default};
  `}

  @media (max-width: ${DEVICE_SIZES.tablet}) {
    overflow: hidden !important;
  }
`;

export const LogIn = styled.div`
  cursor: pointer;
  ${({ theme }) => `
    color: ${theme.brandInverted};

    &:hover {
      color: ${theme.colorInfoHover};
    }
  `}
`;
